import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ProgramacionForm from "./ProgramacionForm";
import ProgramacionLista from "./ProgramacionLista";

const useStyles = makeStyles((theme) => ({
    cardCrear: {
        height: 120,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            cursor: "pointer",
        },
    },
    inputNuevaBanda: {
        width: "100%",
    },
}));

function ProgramacionHub() {
    const classes = useStyles();
    const [drawer, setDrawer] = React.useState(false);
    const [recargarTabla, setRecargarTabla] = React.useState(false);
    const [keyLista, setKeyLista] = React.useState(0);

    React.useEffect(() => {
        document.title = "Mda - Turnos Moratoria - Proteccionistas";
    }, []);

    return (
        <Grid container spacing={4}>
            <Drawer
                className={classes.drawerBanda}
                anchor="right"
                open={drawer}
                onClose={() => setDrawer(false)}
            >
                <ProgramacionForm
                    setRecargarTabla={setRecargarTabla}
                    keyLista={keyLista}
                    setKeyLista={setKeyLista}
                    drawer={setDrawer}
                />
            </Drawer>
            <Grid item md={9}>
                <Card style={{ height: 120, width: "100%" }}>
                    <CardContent>
                        <Typography variant="h5">Hub Programacion</Typography>
                        {/* <Typography>
                        Crear, modificar, y eliminar Programaciones
                        </Typography> */}
                    </CardContent>
                </Card>
            </Grid>
            <Grid item md={3}>
                <Card
                    elevation={8}
                    className={classes.cardCrear}
                    onClick={() => setDrawer(true)}
                >
                    <CardContent>
                        <Typography variant="h5">Programar</Typography>
                        {/* <Typography>Crear nueva Programación</Typography> */}
                    </CardContent>
                </Card>
            </Grid>
            <ProgramacionLista
                recargarTabla={recargarTabla}
                setRecargarTabla={setRecargarTabla}
            />
        </Grid>
    );
}
export default ProgramacionHub;
